import { MailView } from "@/components/toggles/MailViewToggle";
import { useTranslation } from "react-i18next";
import EmailListSkeleton from "./EmailListSkeleton";
import EmailMosaicSkeleton from "./EmailMosaicSkeleton";

type EmailViewSkeletonProps = {
    mosaicColumns?: number;
    showCustomViewMessage?: boolean;
    view: MailView;
};

const EmailViewSkeleton = ({
    mosaicColumns,
    showCustomViewMessage = false,
    view,
}: EmailViewSkeletonProps) => {
    const { t } = useTranslation();
    const isMosaicView = view === MailView.GRID;
    const squeeze = view === MailView.SIDE_LIST;

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            {showCustomViewMessage && (
                <p className="mb-4 text-center text-sm font-medium text-text-body">
                    {t("emails.customViewLoading")}
                </p>
            )}
            {isMosaicView ? (
                <EmailMosaicSkeleton columns={mosaicColumns} />
            ) : (
                <EmailListSkeleton squeeze={squeeze} />
            )}
        </div>
    );
};

export default EmailViewSkeleton;
